import * as staffApi from '../../api/staffApi'

const state = {
  resultData: {},
  employerObj: {}
}

const actions = {
  async EmployerInsertAndEdit ({ commit }, obj) {
    const response = await staffApi.EmployerInsertAndEdit(obj)
    if (response) {
      commit('SetOperationStatus', response)
    }
  },
  async QueryEmployerById ({commit}, employerId) {
    const response = await staffApi.QueryEmployerById(employerId)
    if (response) {
      commit('SetEmployerObj', response)
    }
  },
  async EmployerUntieRelation ({commit}, obj) {
    const response = await staffApi.EmployerUntieRelation(obj)
    if (response) {
      commit('SetOperationStatus', response)
    }
  }
}
const mutations = {
  SetOperationStatus (state, data) {
    state.resultData = data
  },
  SetEmployerObj (state, data) {
    state.employerObj = data.Data
  }

}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/employer.js